import React, { useEffect, useState } from "react";
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import Input from "@amzn/meridian/input";
import Select, { SelectOption, SelectOptionGroup } from "@amzn/meridian/select";
import Button from "@amzn/meridian/button";
import { formatKeywordSearchRequest, searchMailTypeOptions, searchTypeOptions } from "./utils";
import { SearchTable } from "./SearchTable";
import { Space } from "../space/Space";
import { useSheets } from "../../features/sheets/hooks";
import { useFilterSheets } from "../../features/filter-sheets/hooks";
import { useTable } from "../table/hooks";
import { filtersByMailType } from "../../features/filter-sheets/utils";
import { GetArtifactsRequest } from "../../endpoints/getArtifacts";
import { useEditingDocument } from "../edit-document-modal/hooks";

export const Search: React.FC = () => {
    const [type, setType] = useState("mail");
    const [mailType, setMailType] = useState("");
    const [query, setQuery] = useState("");
    const [request, setRequest] = React.useState<GetArtifactsRequest>();
    const [isSearchTableVisible, setIsSearchTableVisible] = useState(false);
    const onSubmit = () => {
        if (query.trim()) {
            setRequest(formatKeywordSearchRequest(currentTable, query));
            setCalendarTableVisible(false);
            setIsSearchTableVisible(true);
        }
    };

    const { updateSheets, setOpenSheets } = useSheets();
    const { isEditSheetOpen } = useEditingDocument();
    const { currentTable, isCalendarVisible, updateCurrentTable, setCalendarTableVisible } =
        useTable();
    const { resetFilters } = useFilterSheets();

    useEffect(() => {
        if (type !== "mail") {
            setOpenSheets(false);
            updateSheets(<></>);
            updateCurrentTable(type);
            setCalendarTableVisible(false);
            setIsSearchTableVisible(false);
        } else {
            updateSheets(filtersByMailType[mailType]);
            updateCurrentTable(mailType);
            resetFilters();
            setOpenSheets(false);
            setCalendarTableVisible(false);
            setIsSearchTableVisible(false);
        }
    }, [type, mailType]);

    useEffect(() => {
        setMailType("tax-bill-personal");
    }, []);

    useEffect(() => {
        if (!isEditSheetOpen && !isCalendarVisible) {
            onSubmit();
        }
    }, [isEditSheetOpen]);

    return (
        <div>
            <Row wrap={"down"} width={"fit"} widths={["fit", "fit", "fill", "fit"]}>
                <Select
                    label="Type"
                    value={type}
                    onChange={e => {
                        setType(e);
                    }}
                    width={"fit"}
                    size={"large"}
                >
                    {searchTypeOptions.map(type => {
                        return <SelectOption value={type.value} label={type.label} />;
                    })}
                </Select>
                {type === "mail" ? (
                    <Select
                        size={"large"}
                        label="Mail Type"
                        value={mailType}
                        onChange={setMailType}
                        width={"fit"}
                    >
                        <SelectOptionGroup label="Real property">
                            {searchMailTypeOptions
                                .filter(type => type.propertyType === "REAL_PROPERTY")
                                .map(type => {
                                    return <SelectOption value={type.value} label={type.label} />;
                                })}
                        </SelectOptionGroup>
                        <SelectOptionGroup label="Personal property">
                            {searchMailTypeOptions
                                .filter(type => type.propertyType === "PERSONAL_PROPERTY")
                                .map(type => {
                                    return <SelectOption value={type.value} label={type.label} />;
                                })}
                        </SelectOptionGroup>
                    </Select>
                ) : (
                    <div />
                )}
                <Input
                    aria-label="Label"
                    type="text"
                    size="large"
                    placeholder="e.g. DAL2"
                    label="Search by keywords"
                    value={query}
                    onChange={setQuery}
                    onKeyDown={({ key }) => (key === "Enter" ? onSubmit() : null)}
                />
                <Box spacingInset="300 0 0 0">
                    <Space size={"s"} />
                    <Button onClick={onSubmit} size={"large"} type="tertiary">
                        Search
                    </Button>
                </Box>
            </Row>
            {isSearchTableVisible && !isCalendarVisible && (
                <SearchTable
                    setIsSearchTableVisible={setIsSearchTableVisible}
                    searchRequest={request}
                />
            )}
        </div>
    );
};
